<div class="hockey-competition-detail">
  <div class="competition-header">
    <p-button 
      icon="pi pi-arrow-left" 
      [text]="true" 
      class="back-button"
      (onClick)="goBack()"
      pTooltip="Regresar a la lista de competiciones"
      tooltipPosition="right">
    </p-button>
    <h2>{{ competition.name }}</h2>
  </div>
   <p-toast key="inscriptionFeeUpdate"/>

  <p-tabView
    (onChange)="onTabChange($event)"
    [activeIndex]="activeTabIndex"
    *ngIf="competitionCategories.length > 0"
  >
    <p-tabPanel
      *ngFor="let category of competitionCategories; let i = index"
      [header]="category.name"
    >
      <div class="category-content" *ngIf="activeTabIndex === i">
        <div class="category-header">
          <div class="category-info">
            <h3>{{ category.name }}</h3>
            <div class="inscription-fee-info">
              <span class="fee-label">Valor de inscripción:</span>
              <p-tag
                [value]="formatCurrency(getInscriptionFee(category.id))"
                [severity]="getInscriptionFee(category.id) > 0 ? 'success' : 'warning'"
                icon="pi pi-dollar">
              </p-tag>
              <p-tag
                [value]="competition.customData?.['paymentModel'] === 'PER_ATHLETE' ? 'Por Atleta' : 'Por Equipo'"
                [severity]="competition.customData?.['paymentModel'] === 'PER_ATHLETE' ? 'info' : 'secondary'"
                icon="pi pi-users"
                styleClass="ml-2">
              </p-tag>
            </div>
          </div>
          <div class="category-actions">
            <p-button
              icon="pi pi-download"
              label="Exportar Todos los Equipos "
              severity="success"
              [outlined]="true"
              size="small"
              (onClick)="exportCategoryPlayerTemplate()"
              pTooltip="Exportar plantilla de jugadores de toda la categoría"
              tooltipPosition="left"
              styleClass="export-button">
            </p-button>
            <p-button
              *ngIf="competition.hasCrosselling"
              label="Reporte Financiero"
              icon="pi pi-file-excel"
              size="small"
              severity="success"
              (onClick)="exportFinancialReport()"
              pTooltip="Exportar reporte financiero con detalle de venta cruzada"
              tooltipPosition="left"
              styleClass="export-button">
            </p-button>
            <p-button
              icon="pi pi-cog"
              label="Configurar Inscripción"
              severity="primary"
              [outlined]="true"
              size="small"
              (onClick)="showInscriptionFeeConfiguration(category)"
              pTooltip="Configurar valor de inscripción para esta categoría"
              tooltipPosition="left"
              styleClass="inscription-config-button">
            </p-button>
          </div>
        </div>
        <div
          class="teams-section"
          *ngIf="sortedTeamRegistrations.length > 0; else noTeams"
        >
          <p-table
            [value]="sortedTeamRegistrations"
            [rowGroupMode]="'subheader'"
            groupRowsBy="clubId"
            [sortField]="'clubId'"
            [sortOrder]="1"
            dataKey="id"
            styleClass="p-datatable-gridlines"
            responsiveLayout="scroll"
          >
            <ng-template pTemplate="groupheader" let-team>
              <tr class="p-rowgroup-header">
                <td [attr.colspan]="competition.hasCrosselling ? 9 : 8">
                  <div class="club-header-row">
                    <i class="pi pi-building"></i>
                    <span class="club-name">{{
                      getClubName(team.clubId)
                    }}</span>
                    <p-tag
                      [value]="getTeamCountForClub(team.clubId) + ' equipo(s)'"
                      severity="info"
                    >
                    </p-tag>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th>Club</th>
                <th>Equipo</th>
                <th>Rama</th>
                <th>Tipo de Registro</th>
                <th>Estado</th>
                <th>Estado de Pago</th>
                <th *ngIf="competition.hasCrosselling">Venta Cruzada</th>
                <th>Miembros</th>
                <th>Acciones</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-team>
              <tr>
                <td>
                  <div class="club-info">
                    <span class="club-name">{{
                      getClubName(team.clubId)
                    }}</span>
                    <small class="club-id">{{ team.clubId }}</small>
                  </div>
                </td>
                <td>
                  <div class="team-name">
                    <strong>{{ team.name }}</strong>
                    <p-tag
                      *ngIf="hasTeamAgeErrors(team)"
                      value="Ajuste de Categoría"
                      severity="danger"
                      icon="pi pi-exclamation-triangle"
                      [pTooltip]="'Este equipo tiene ' + countMembersWithAgeError(team) + ' deportista(s) que no cumplían la edad mínima al inicio del torneo'"
                      tooltipPosition="right"
                      styleClass="age-error-tag">
                    </p-tag>
                    <div class="team-id" *ngIf="team.id">
                      <small>ID: {{ team.id }}</small>
                    </div>
                  </div>
                </td>

                <td>
                  <p-tag [value]="category.branch" severity="info"></p-tag>
                </td>
                <td>
                  <p-tag
                    [value]="team.registrationType === 'TEAM_REGISTRATION' ? 'Registro Equipo' : 'N/A'"
                    severity="secondary"
                  ></p-tag>
                </td>
                <td>
                  <p-tag
                    [value]="getStatusLabel(team.status)"
                    [severity]="getStatusSeverity(team.status)"
                  >
                  </p-tag>
                </td>
                <td>
                  <p-tag
                    [value]="team.payment.paymentStatus === 'PAYMENT_PENDING' ? 'Pendiente' : team.payment.paymentStatus === 'PAYMENT_COMPLETED' ? 'Pagado' : 'N/A'"
                    [severity]="getPaymentSeverity(team.payment.paymentStatus)"
                  >
                  </p-tag>
                </td>
                <td *ngIf="competition.hasCrosselling">
                  {{ getTotalCrosselingAmount(team) | currency:'COP':'symbol':'1.0-0' }}
                </td>
                <td>
                  <div class="members-column">
                    <div
                      class="members-info"
                      *ngIf="team.members && team.members.length > 0; else noMembers"
                    >
                      <i class="pi pi-users"></i>
                      <span>{{ team.members.length }}</span>
                      <p-button
                        icon="pi pi-eye"
                        size="small"
                        severity="info"
                        [text]="true"
                        (onClick)="showTeamMembers(team)"
                        pTooltip="Ver miembros del equipo"
                      ></p-button>
                    </div>
                    <ng-template #noMembers>
                      <div class="no-members-action">
                        <span class="no-members">Sin miembros</span>
                        <p-button
                          icon="pi pi-user-plus"
                          size="small"
                          severity="success"
                          [text]="true"
                          (onClick)="showTeamMembers(team)"
                          pTooltip="Gestionar miembros del equipo"
                        ></p-button>
                      </div>
                    </ng-template>
                  </div>
                </td>
                <td>
                  <div class="team-actions">
                    <p-button
                      icon="pi pi-download"
                      severity="success"
                      [text]="true"
                      size="small"
                      (onClick)="exportTeamPlayerTemplate(team)"
                      pTooltip="Exportar plantilla de jugadores del equipo"
                      [disabled]="!team.members || team.members.length === 0">
                    </p-button>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="groupfooter">
              <tr class="p-rowgroup-footer">
                <td [attr.colspan]="competition.hasCrosselling ? 9 : 8" style="text-align: right">
                  <!-- Pie de grupo si es necesario -->
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>

        <ng-template #noTeams>
          <div class="no-teams-message">
            <i class="pi pi-info-circle"></i>
            <p>No hay equipos registrados en esta categoría</p>
          </div>
        </ng-template>
      </div>
    </p-tabPanel>
  </p-tabView>

  <div class="no-categories-message" *ngIf="competitionCategories.length === 0">
    <i class="pi pi-info-circle"></i>
    <p>No hay categorías disponibles para esta competición</p>
  </div>
</div>

<!-- Team Members Modal -->
<app-hockey-team-members-modal
  [visible]="showMembersModal"
  [team]="selectedTeam!"
  [category]="selectedCategory!"
  [competition]="competition"
  [levels]="Levels"
  (onClose)="onMembersModalClose()"
  *ngIf="selectedTeam && selectedCategory"
></app-hockey-team-members-modal>

<!-- Inscription Fee Modal -->
<app-hockey-inscription-fee-modal
  [visible]="showInscriptionFeeModal"
  [competition]="competition"
  [category]="selectedFeeCategory!"
  [paymentModel]="competition.customData?.['paymentModel'] || 'PER_TEAM'"
  (onClose)="onInscriptionFeeModalClose($event)"
  *ngIf="selectedFeeCategory"
></app-hockey-inscription-fee-modal>
